// Root application component.
//
// Composes the auth provider, browser router, and route table. All routes
// inherit access to useAuth() through this provider.

import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";

import { AuthProvider } from "@/auth/AuthProvider";
import { AppRouter } from "@/routing/AppRouter";
import { queryClient } from "@/lib/queryClient";

function App(): JSX.Element {
  return (
    <BrowserRouter>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <AppRouter />
        </QueryClientProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
